const ATTR_TYPEAHEAD_INPUT = 'data-klt-c-typeahead';
const ATTR_TYPEAHEAD_ENDPOINT = 'data-klt-c-typeahead-callback-endpoint';
const CSS_CLASS_NAMESPACE = 'klt-c-typeahead';

interface TypeaheadProps {
    selector?: string;
    vendorRoot?: string;
    callbackFn?: Function;
    callbackEndpoint?: string;
}

export default function init(
    { selector, vendorRoot, callbackFn, callbackEndpoint }: TypeaheadProps = {
        selector: `[${ATTR_TYPEAHEAD_INPUT}]`,
        vendorRoot: '',
    }
) {
    try {
        selector = selector || `[${ATTR_TYPEAHEAD_INPUT}]`;
        vendorRoot = vendorRoot || '';

        const elements = document.querySelectorAll(selector);

        if (elements && elements.length > 0) {
            import('../../../assets/js/vendor/accessible-autocomplete.min.js').then(() => {
                const accessibleAutocomplete = (window as any).accessibleAutocomplete;

                elements.forEach((element) => {
                    const optionsEncoded = element.getAttribute(ATTR_TYPEAHEAD_INPUT);
                    const callbackEndpoint = element.getAttribute(ATTR_TYPEAHEAD_ENDPOINT);
                    const name = element.getAttribute('name') || undefined;

                    if (optionsEncoded) {
                        // Options can either be an array of string or an array of objects containing the "text" attribute
                        const options = JSON.parse(optionsEncoded).map((option) => option.text || option);

                        // Transfer important properties from the HTML input field fallback to the typeahead generated field
                        const div = document.createElement('div');
                        const attr = [];
                        const id = element.id;

                        attr.push({ key: 'id', value: element.id });
                        attr.push({ key: 'placeholder', value: element.getAttribute('placeholder') });
                        attr.push({ key: 'value', value: element.getAttribute('value') });

                        element.parentNode.insertBefore(div, element.nextSibling);

                        // We now hava div we're gonna use for the plugin to work. Delete native input element.
                        element.remove();

                        const autocomplete = accessibleAutocomplete({
                            element: div,
                            id,
                            name,
                            source: options,
                            cssNamespace: CSS_CLASS_NAMESPACE,
                            showNoOptionsFound: false,
                        });

                        const autocompletInputElement: HTMLInputElement = document.getElementById(
                            id
                        ) as HTMLInputElement;

                        if (autocompletInputElement) {
                            attr.forEach((attribute) => {
                                if (attribute.value) {
                                    if (attribute.key === 'value') {
                                        autocompletInputElement.value = attribute.value;
                                    } else {
                                        autocompletInputElement.setAttribute(attribute.key, attribute.value);
                                    }
                                }
                            });
                        }
                    }
                });
            });
        }
    } catch (e) {
        console.error(`Couldn't initalize typeahead module.`, e);
    }
}
